window.addEventListener("load", function () {
    var swiperThumb = new Swiper(".swiper-thumb", {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          769: {
            slidesPerView: 4,
          }
        },
    });
    var swiper = new Swiper(".swiper-feature", {
        slidesPerView: "auto",
        centeredSlides: true,
        loop: document.querySelectorAll(".swiper-feature .swiper-slide").length > 1,
        //spaceBetween: 0,
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0,
          //   stretch: 438,
          stretch: 296,
          depth: 180,
          modifier: 1,
          slideShadows: false,
        },
        lazy: {
          loadPrevNext: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 5000,
        },
        speed: 600,
        breakpoints: {
          769: {
            slidesPerView: "auto",
            effect: "coverflow",
            coverflowEffect: {
              stretch: 420,
              depth: 255,
            },
          },
        },
        thumbs: {
            swiper: swiperThumb,
        },
        
    });
});